<template>
  <div class="flex flex-col bg-[#f8fafc] gap-4">
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] flex flex-col pt-3">
      <div class="relative z-30 px-6 pb-3 flex flex-col gap-4 border-b border-slate-100 bg-white">
        <h2 class="text-base font-bold text-[#0d4169] text-left m-0">HR</h2>
      </div>

      <div class="relative z-0 px-6 py-4">
        <div class="bg-white shadow-sm border border-slate-200 overflow-hidden">
          <div class="px-6 pt-2 pb-1">
            <div class="flex items-baseline gap-2 flex-wrap">
              <h2 class="text-base font-bold text-[#0d4169] text-left">
                Leaving Type
              </h2>
            </div>
          </div>

          <form @submit.prevent="save" class="px-6 pb-5 pt-2">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-2">
              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Leave Type/Name</label>
                <input
                  v-model.trim="form.leaveTypeName"
                  type="text"
                  placeholder="Leave Type/Name"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                  required
                />
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">No Days Per/Year</label>
                <input
                  v-model.number="form.noDaysPerYear"
                  type="number"
                  min="0"
                  step="1"
                  placeholder="No Days Per/Year"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                  required
                />
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Increment Year</label>
                <input
                  v-model.number="form.incrementYear"
                  type="number"
                  min="0"
                  step="1"
                  placeholder="Increment Year"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                  required
                />
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Increasing Days Per/year</label>
                <input
                  v-model.number="form.increasingDaysPerYear"
                  type="number"
                  min="0"
                  step="1"
                  placeholder="Increasing Days Per/year"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                  required
                />
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Condition / Evidence</label>
                <select
                  v-model="form.conditionEvidence"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
                  required
                  @change="onConditionEvidenceChange"
                >
                  <option value="" disabled>Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">Is Expirable </label>
                <select
                  v-model="form.decreaseFromYearlyLeave"
                  :disabled="!canEditDecreaseFromYearlyLeave"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white"
                  :class="canEditDecreaseFromYearlyLeave ? 'cursor-pointer' : 'cursor-not-allowed opacity-60 bg-slate-100'"
                  required
                  @change="onDecreaseFromYearlyLeaveChange"
                >
                  <option value="" disabled>Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div v-if="form.decreaseFromYearlyLeave === 'Yes'" class="flex flex-col gap-1">
                <label class="text-[0.78rem] font-semibold text-[#1e293b] text-left">In how many years</label>
                <input
                  v-model.number="form.howManyYears"
                  type="number"
                  min="1"
                  step="1"
                  placeholder="In how many years"
                  class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
                  required
                />
              </div>
            </div>

            <p v-if="formError" class="mt-3 text-sm text-red-600 text-left">{{ formError }}</p>

            <div class="mt-4 flex justify-center items-center gap-3">
              <button
                type="submit"
                :disabled="saving || (editingId != null ? !canEditAnnualLeavingType : !canAddAnnualLeavingType)"
                class="min-w-[160px] px-5 py-1.5 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <div
                  v-if="saving"
                  class="h-5 w-5 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
                ></div>
                <span v-if="!saving">{{ editingId != null ? 'Update' : 'Save' }}</span>
              </button>
              <button
                v-if="editingId != null"
                type="button"
                :disabled="saving"
                class="px-4 py-1.5 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors disabled:opacity-50"
                @click="resetForm"
              >
                Cancel
              </button>
            </div>
          </form>

          <div class="px-6 pb-6">
            <p v-if="errorMessage" class="mb-3 text-sm text-red-600">{{ errorMessage }}</p>
            <div class="w-full overflow-x-auto">
              <table class="w-full min-w-[980px] border-collapse bg-white rounded-xl overflow-hidden shadow-sm">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th @click="sortBy('leaveTypeName')" class="sort-col">
                      Leave Type/Name
                      <span v-if="sortKey === 'leaveTypeName'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('noDaysPerYear')" class="sort-col">
                      No Days Per/Year
                      <span v-if="sortKey === 'noDaysPerYear'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('incrementYear')" class="sort-col">
                      Increment Year
                      <span v-if="sortKey === 'incrementYear'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('increasingDaysPerYear')" class="sort-col">
                      Increasing Days Per/year
                      <span v-if="sortKey === 'increasingDaysPerYear'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('conditionEvidence')" class="sort-col">
                      Condition / Evidence
                      <span v-if="sortKey === 'conditionEvidence'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('decreaseFromYearlyLeave')" class="sort-col">
                      Is Expirable 
                      <span v-if="sortKey === 'decreaseFromYearlyLeave'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th @click="sortBy('howManyYears')" class="sort-col">
                      In how many years
                      <span v-if="sortKey === 'howManyYears'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="9" class="text-center py-10">
                      <div class="flex items-center justify-center">
                        <div class="h-8 w-8 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(row, idx) in sortedRows"
                    v-else
                    :key="row.id"
                    class="hover:bg-slate-100/50 transition-colors border-b"
                  >
                    <td>{{ idx + 1 }}</td>
                    <td>{{ row.leaveTypeName }}</td>
                    <td>{{ row.noDaysPerYear }}</td>
                    <td>{{ row.incrementYear }}</td>
                    <td>{{ row.increasingDaysPerYear }}</td>
                    <td>{{ row.conditionEvidence }}</td>
                    <td>{{ row.decreaseFromYearlyLeave }}</td>
                    <td>{{ row.howManyYears != null ? row.howManyYears : '—' }}</td>
                    <td class="actions">
                      <button type="button" @click="editEntry(row)">
                        Edit
                      </button>
                      <label class="toggle-switch" title="Active">
                        <input
                          type="checkbox"
                          :checked="row.active"
                          :disabled="togglingId === row.id"
                          @change="toggleActive(row)"
                        >
                        <span class="slider"></span>
                      </label>
                    </td>
                  </tr>
                  <tr v-if="!loading && rows.length === 0">
                    <td colspan="9" style="text-align:center; color:#94a3b8; padding: 32px 15px; font-style: italic;">
                      No Leaving Types saved.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { apiFetch } from '../../../utils/api'

const API_BASE = '/hr/annual-leaving-type'
const PRIVILEGE_NAME = 'HR Leaving Type'

const store = useStore()
const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

const userPrivileges = computed(() => {
  const raw = currentUser.value?.privilege
  if (!raw) return {}
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
  return raw
})

const hasAllPrivilege = computed(() => {
  return userPrivileges.value?.All === true || userPrivileges.value?.all === true
})

function getPrivilegeEntry(key) {
  const priv = userPrivileges.value || {}
  if (!key) return null
  if (priv?.[key]) return priv[key]

  const normalizedNeedle = String(key).trim().toLowerCase()
  const foundKey = Object.keys(priv).find((k) => String(k).trim().toLowerCase() === normalizedNeedle)
  return foundKey ? priv[foundKey] : null
}

function getActionFlag(entry, action) {
  if (!entry || typeof entry !== 'object') return false
  if (!action) return false
  if (entry[action] !== undefined) return !!entry[action]

  const a = String(action)
  const candidates = [
    a.toLowerCase(),
    a.toUpperCase(),
    a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  ]
  for (const k of candidates) {
    if (entry[k] !== undefined) return !!entry[k]
  }
  return false
}

const canAddAnnualLeavingType = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry(PRIVILEGE_NAME), 'Add')
})

const canEditAnnualLeavingType = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry(PRIVILEGE_NAME), 'Edit')
})

const form = reactive({
  leaveTypeName: '',
  noDaysPerYear: null,
  incrementYear: null,
  increasingDaysPerYear: null,
  conditionEvidence: '',
  decreaseFromYearlyLeave: '',
  howManyYears: null,
})

const rows = ref([])
const loading = ref(false)
const saving = ref(false)
const errorMessage = ref('')
const formError = ref('')
const editingId = ref(null)
const togglingId = ref(null)
const sortKey = ref('leaveTypeName')
const sortOrder = ref('asc')

/** Is Expirable  is editable only when Condition / Evidence is No */
const canEditDecreaseFromYearlyLeave = computed(() => form.conditionEvidence === 'No')

const numericSortKeys = new Set(['noDaysPerYear', 'incrementYear', 'increasingDaysPerYear', 'howManyYears'])

const sortedRows = computed(() => {
  const result = [...rows.value]

  result.sort((a, b) => {
    if (!!a.active !== !!b.active) {
      return a.active ? -1 : 1
    }

    const modifier = sortOrder.value === 'asc' ? 1 : -1
    const key = sortKey.value

    if (numericSortKeys.has(key)) {
      const valA = Number(a[key] ?? 0)
      const valB = Number(b[key] ?? 0)
      if (valA < valB) return -1 * modifier
      if (valA > valB) return 1 * modifier
      return 0
    }

    const valA = (a[key] ?? '').toString().toLowerCase()
    const valB = (b[key] ?? '').toString().toLowerCase()
    if (valA < valB) return -1 * modifier
    if (valA > valB) return 1 * modifier
    return 0
  })

  return result
})

function sortBy(key) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function onConditionEvidenceChange() {
  if (form.conditionEvidence !== 'No') {
    form.decreaseFromYearlyLeave = 'No'
    form.howManyYears = null
  }
}

function onDecreaseFromYearlyLeaveChange() {
  if (form.decreaseFromYearlyLeave !== 'Yes') {
    form.howManyYears = null
  }
}

function resetForm() {
  form.leaveTypeName = ''
  form.noDaysPerYear = null
  form.incrementYear = null
  form.increasingDaysPerYear = null
  form.conditionEvidence = ''
  form.decreaseFromYearlyLeave = ''
  form.howManyYears = null
  editingId.value = null
  formError.value = ''
}

function isFormValid() {
  if (!form.leaveTypeName) return false
  if (form.noDaysPerYear === null || form.noDaysPerYear === '') return false
  if (form.incrementYear === null || form.incrementYear === '') return false
  if (form.increasingDaysPerYear === null || form.increasingDaysPerYear === '') return false
  if (!form.conditionEvidence || !form.decreaseFromYearlyLeave) return false
  if (form.decreaseFromYearlyLeave === 'Yes') {
    if (form.howManyYears === null || form.howManyYears === '') return false
    if (!Number.isFinite(Number(form.howManyYears)) || Number(form.howManyYears) < 1) return false
  }
  return true
}

async function fetchRows() {
  loading.value = true
  errorMessage.value = ''
  try {
    const res = await apiFetch(API_BASE)
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.message || 'Failed to load Leaving Types')
    }
    const data = await res.json().catch(() => [])
    rows.value = Array.isArray(data) ? data : []
  } catch (err) {
    console.error('Error loading Leaving Types:', err)
    rows.value = []
    errorMessage.value = err.message || 'Failed to load Leaving Types'
  } finally {
    loading.value = false
  }
}

async function save() {
  if (saving.value) return
  if (editingId.value != null) {
    if (!canEditAnnualLeavingType.value) return
  } else if (!canAddAnnualLeavingType.value) {
    return
  }
  formError.value = ''

  // Keep decrease locked to No when Condition / Evidence is not No
  if (form.conditionEvidence !== 'No') {
    form.decreaseFromYearlyLeave = 'No'
    form.howManyYears = null
  }
  if (form.decreaseFromYearlyLeave !== 'Yes') {
    form.howManyYears = null
  }

  if (!isFormValid()) {
    formError.value = 'Please fill in all required fields.'
    return
  }

  const payload = {
    leaveTypeName: form.leaveTypeName,
    noDaysPerYear: form.noDaysPerYear,
    incrementYear: form.incrementYear,
    increasingDaysPerYear: form.increasingDaysPerYear,
    conditionEvidence: form.conditionEvidence,
    decreaseFromYearlyLeave: form.decreaseFromYearlyLeave,
    howManyYears: form.decreaseFromYearlyLeave === 'Yes' ? form.howManyYears : null,
  }

  saving.value = true
  try {
    const isEdit = editingId.value != null
    const res = await apiFetch(
      isEdit ? `${API_BASE}/${editingId.value}` : API_BASE,
      {
        method: isEdit ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }
    )
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      throw new Error(data.message || (isEdit ? 'Failed to update leave type' : 'Failed to save leave type'))
    }
    resetForm()
    await fetchRows()
  } catch (err) {
    console.error('Error saving Leaving Type:', err)
    formError.value = err.message || 'Failed to save leave type'
  } finally {
    saving.value = false
  }
}

function editEntry(row) {
  editingId.value = row.id
  form.leaveTypeName = row.leaveTypeName
  form.noDaysPerYear = row.noDaysPerYear
  form.incrementYear = row.incrementYear
  form.increasingDaysPerYear = row.increasingDaysPerYear
  form.conditionEvidence = row.conditionEvidence
  form.decreaseFromYearlyLeave =
    row.conditionEvidence === 'No' ? row.decreaseFromYearlyLeave : 'No'
  form.howManyYears =
    form.decreaseFromYearlyLeave === 'Yes' && row.howManyYears != null
      ? Number(row.howManyYears)
      : null
  formError.value = ''
}

async function toggleActive(row) {
  if (!row?.id || togglingId.value) return
  togglingId.value = row.id
  errorMessage.value = ''
  try {
    const res = await apiFetch(`${API_BASE}/${row.id}/status`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ active: !row.active }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      throw new Error(data.message || 'Failed to update status')
    }
    const idx = rows.value.findIndex((r) => r.id === row.id)
    if (idx >= 0) {
      rows.value[idx] = { ...rows.value[idx], ...data }
    } else {
      await fetchRows()
    }
  } catch (err) {
    console.error('Error toggling Leaving Type status:', err)
    window.alert(err.message || 'Failed to update status')
  } finally {
    togglingId.value = null
  }
}

onMounted(() => {
  fetchRows()
})
</script>

<style scoped>
table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.8rem;
  color: #1e293b;
}

th,
td {
  padding: 6px 8px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  font-size: 0.7rem;
}

th {
  background: #f1f5f9;
  font-weight: 600;
  cursor: default;
}

th.sort-col {
  cursor: pointer;
}

th.sort-col:hover {
  background: #e2e8f0;
}

tbody tr:hover {
  background: #f1f5f9;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.actions button {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.85rem;
  padding: 0;
  display: flex;
  align-items: center;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 15px;
  cursor: pointer;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  inset: 0;
  background: #ef4444;
  border-radius: 34px;
  transition: 0.2s;
}

.slider::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  left: 2px;
  bottom: 2.5px;
  background: white;
  border-radius: 50%;
  transition: 0.2s;
}

.toggle-switch input:checked + .slider {
  background: #22c55e;
}

.toggle-switch input:checked + .slider::before {
  transform: translateX(13px);
}
</style>
